<template>
	<div class="cart-info-message-wrap">
		<div class="cart-info-message">
			<span v-if="message && message.title" class="cart-info-title">
				{{ message.title }}
			</span>
			<span v-if="message && message.subTitle" class="cart-info-subtitle">
				{{ message.subTitle }}
			</span>
			<button class="btn-close" @click="hideInfoMessage" />
		</div>
	</div>
</template>

<script>
export default {
	name: 'CartInfoMessage',

	props: {
		message: {
			type: Object,
			default: () => {}
		}
	},

	methods: {
		hideInfoMessage() {
			this.$emit('hide')
		}
	}
}
</script>

<style lang="scss">
.cart-info-message-wrap {
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	flex-shrink: 0;
	position: relative;
	overflow: hidden;
}

.cart-info-message {
	position: relative;
	padding: 11px 36px 14px;
	color: #fff;
	text-align: center;
	background: #554781;

	.btn-close {
		position: absolute;
		right: 10px;
		top: 10px;
	}
}

.cart-info-title {
	display: block;
	padding: 0 0 7px;
	font-size: 12px;
}

.cart-info-subtitle {
	font-size: 18px;
	font-weight: 700;
}
</style>
